import React from "react"
import { useNavigate } from 'react-router-dom';

import logo from "../logo.png"
import '../App.css';

function LogoutPageComponent() {
    const navigate = useNavigate()

    function redirectToLogin(event) {
        event.preventDefault()
        navigate("/login")
        window.location.reload()
    }

  return (
    <div className="login">
      <header className="login_header">
        <img src={logo} className="app__logo__still" alt="logo" />
            <h1 className="logout__text">You have successfully been logged out!</h1>
            <button className="return__login__button" onClick={redirectToLogin}>Return to Login</button>
      </header>
    </div>
  );
}

export default LogoutPageComponent;